export default __webpack_public_path__ + "static/media/Padron_1926.58b85f2c.jpg";